



































































import { DueDateSettingType, ExpenseType, FinanceType, LoadingStatusType, TransactionType } from "@/enums/enums";
import { GetDueDateFromSetting, SetDueDate } from "@/helper/dateTimeHelper";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreContact = namespace("Contact");
const StoreTransaction = namespace("Transaction");
const StoreSetting = namespace("Setting");

@Component
export default class SectionContact extends Vue {
  @Prop({}) readonly transactionCreate!: any;
  @Prop({}) readonly isHiddenDueDateInput!: boolean;
  private selectValue: any = "";
  private options: any = [];
  private financeType = FinanceType;
  private dueDateType: DueDateSettingType = DueDateSettingType.DateDistanct;
  private day = 7;

  @StoreContact.Getter
  private getContactListLoadingStatus!: LoadingStatusType;
  @StoreContact.Getter
  private getContactList!: any;

  @StoreContact.Action
  private DoGetAllContact!: () => void;

  @StoreTransaction.Getter
  private getAiSuggestionTransaction!: any;
  @StoreTransaction.Getter
  private getAiSuggestionTransactionLoadingStatus!: LoadingStatusType;

  @StoreSetting.Getter
  private getSettingTransactionDueDate!: any;
  @StoreSetting.Getter
  private getSettingTransactionDueDateLoadingStatus!: LoadingStatusType;

  @StoreTransaction.Action
  private DoGetAISuggestionAccountByContact!: (input: any) => void;
  @StoreTransaction.Action
  private DoGetPeakAIRecommendation!: (input: any) => void;
  @StoreTransaction.Action
  private DoReSetAISuggestionTransaction!: () => void;

  @StoreSetting.Action
  private DoGetSettingTransactionDueDate!: () => void;

  get isContactLoadingStatus() {
    return this.getContactListLoadingStatus == LoadingStatusType.Loading;
  }

  get selectedContactOption() {
    return this.transactionCreate.contact;
  }

  @Watch("getSettingTransactionDueDateLoadingStatus", { immediate: true })
  getSettingTransactionDueDateLoadingStatusChanged(newValue: LoadingStatusType) {
    if (newValue === LoadingStatusType.Success) {
      this.GetDueDateFromSetting();
      this.SetDate();
    } else if (newValue === LoadingStatusType.None) {
      this.DoGetSettingTransactionDueDate();
    }
  }

  @Watch("transactionCreate.contact.id")
  contactIdChanged(newValue: any, oldValue: any) {
    if (this.getContactListLoadingStatus === LoadingStatusType.Success) {
      this.DoMatchContact();
    }
    if (newValue != oldValue) {
      this.AIRecommendation();
      this.GetDueDateFromSetting();
      this.SetDate();
    }
  }

  @Watch("transactionCreate.contact.code")
  contactCodeChanged(newValue: any) {
    if (this.getContactListLoadingStatus === LoadingStatusType.Success) {
      this.DoMatchContact();
    }
  }

  @Watch("transactionCreate.contact.contactTaxId")
  contactContactTaxIdChanged(newValue: any) {
    if (this.getContactListLoadingStatus === LoadingStatusType.Success) {
      this.DoMatchContact();
    }
  }

  @Watch("getContactListLoadingStatus", { immediate: true })
  getContactListLoadingStatusChange(newVal: LoadingStatusType) {
    if (newVal == LoadingStatusType.None) {
      this.DoGetAllContact();
    } else if (newVal == LoadingStatusType.Success) {
      this.AddMenuContact();
      this.DoMatchContact();
    }
  }

  @Watch("selectValue")
  selectValueChanged() {
    this.DoSelectContact(this.selectValue);
  }

  public DoSelectContact(item: any) {
    if (item && item != "") {
      const selectedContact = this.transactionCreate.contact;
      selectedContact.contactCode = item.contactCode;
      selectedContact.id = item.id;
      selectedContact.contactFullName = item.contactFullName;
      selectedContact.contactBranchCode = item.contactBranchCode;
      selectedContact.contactTaxId = item.contactTaxId;
      selectedContact.address = item.address;
      selectedContact.contactType = item.contactType;
      selectedContact.phoneNumber = item.phoneNumber;
      selectedContact.incomeDueDateTypeId = item.incomeDueDateTypeId;
      selectedContact.incomeDueDateDay = item.incomeDueDateDay;
      selectedContact.outflowDueDateTypeId = item.outflowDueDateTypeId;
      selectedContact.outflowDueDateDay = item.outflowDueDateDay;
      selectedContact.creditLimit = item.creditLimit;
      selectedContact.creditLimitSettingType = item.creditLimitSettingType;
      selectedContact.validateError = false;
      if (item.isArchived) {
        selectedContact.validateError = true;
      }
      this.transactionCreate.contact = selectedContact;
    } else {
      this.SetDefaultContact();
    }
  }

  public SetDefaultContact() {
    const selectedContact = this.transactionCreate.contact;
    selectedContact.contactCode = "";
    selectedContact.id = 0;
    selectedContact.contactFullName = "";
    selectedContact.contactBranchCode = "";
    selectedContact.contactTaxId = "";
    this.transactionCreate.contact = selectedContact;
  }

  public DoMatchContact() {
    this.$nextTick(() => {
      if (this.transactionCreate.contact.id > 0) {
        this.selectValue = this.getContactList.find((x: any) => x.id === this.transactionCreate.contact.id);
      } else if (
        this.transactionCreate.contact.contactCode &&
        this.transactionCreate.contact.contactCode.length !== 0
      ) {
        this.selectValue = this.getContactList.find(
          (x: any) => x.contactCode === this.transactionCreate.contact.contactCode
        );
      } else if (
        this.transactionCreate.contact.contactTaxId &&
        this.transactionCreate.contact.contactTaxId.length !== 0
      ) {
        this.selectValue = this.getContactList.find(
          (x: any) =>
            x.contactTaxId === this.transactionCreate.contact.contactTaxId &&
            x.contactBranchCode === this.transactionCreate.contact.contactBranchCode
        );
        if (!this.selectValue) {
          this.selectValue = this.getContactList.find(
            (x: any) => x.contactTaxId === this.transactionCreate.contact.contactTaxId
          );
        }
      } else {
        this.selectValue = "";
      }
    });
  }

  public AddMenuContact() {
    this.options = [];

    if (this.getContactList.length > 0) {
      for (const contact of this.getContactList) {
        if (!contact.isDeleted && !contact.isArchived) {
          this.options.push(contact);
        }
      }
    }
  }

  public LinkToCreateContact() {
    this.$router.push({
      name: "contactCreate",
      query: {
        etti: this.transactionCreate.transactionType.PeakEncryption(),
        etfi: this.transactionCreate.financeType.PeakEncryption(),
      },
    });
  }

  public GetContactBranch(branchCode: string) {
    if (branchCode === "00000") {
      return `(สำนักงานใหญ่)`;
    } else if (branchCode) {
      return `(${branchCode})`;
    } else {
      return "";
    }
  }

  public AIRecommendation() {
    if (
      this.transactionCreate.financeType == FinanceType.OutFlow &&
      this.transactionCreate.transactionType == TransactionType.Invoice &&
      this.getAiSuggestionTransactionLoadingStatus !== LoadingStatusType.Loading
    ) {
      switch (this.transactionCreate.expenseType) {
        case ExpenseType.Expense:
        case ExpenseType.PurchaseInventory:
          this.DoGetAISuggestionAccountByContact({
            transactionCreate: this.transactionCreate,
            contactId: this.transactionCreate.contact.id,
            contactTaxId: this.transactionCreate.contact.contactTaxId,
          });
          break;
      }
    }
  }
  public OnChangeStartDate() {
    this.GetDueDateFromSetting();
    this.SetDate();
  }

  public GetPeakAIRecommendation(expensType: ExpenseType) {
    if (
      this.getAiSuggestionTransaction &&
      this.getAiSuggestionTransaction.isActive &&
      this.getAiSuggestionTransaction.transactionId > 0 &&
      this.getAiSuggestionTransaction.expenseTypeId > 0
    ) {
      const query = Object.assign({}, this.$route.query);
      if (query.ecpi) {
        delete query.ecpi;
        this.$router.replace({ query });
      }
      if (this.getAiSuggestionTransaction.expenseTypeId == ExpenseType.Expense) {
        this.$router.push({
          name: "expenseCreate",
          query: { ecpi: this.getAiSuggestionTransaction.transactionId.PeakEncryption() },
        });
      } else {
        this.$router.push({
          name: "expense_purchaseInventoryCreate",
          query: { ecpi: this.getAiSuggestionTransaction.transactionId.PeakEncryption() },
        });
      }
    } else if (this.getAiSuggestionTransaction.isActive) {
      this.DoGetPeakAIRecommendation({
        TransactionCreate: this.transactionCreate,
        aiSuggestionTransaction: this.getAiSuggestionTransaction,
        expenseType: expensType,
        contactId: this.transactionCreate.contact.id,
      });
    }
  }
  SetDate() {
    if (!this.transactionCreate.dueDate.isNotAuto && !isNaN(new Date(this.transactionCreate.date.value).getTime())) {
      let date: any = new Date(this.transactionCreate.date.value);
      date = SetDueDate(date, this.dueDateType, this.day);
      this.transactionCreate.dueDate.value = new Date(date).ToDateJsonString();
    }
  }

  public GetDueDateFromSetting() {
    const transactionTypeModel = {
      transactionType: this.transactionCreate.transactionType,
      financeType: this.transactionCreate.financeType,
      expenseType: this.transactionCreate.expenseType,
    };
    const dueDateResult = GetDueDateFromSetting(
      this.getSettingTransactionDueDate,
      this.selectedContactOption,
      transactionTypeModel
    );
    if (dueDateResult.isDueDateSetting) {
      this.transactionCreate.dueDate.value = SetDueDate(
        this.transactionCreate.date.value,
        dueDateResult.dueDateType,
        dueDateResult.day
      );
    }
  }

  destroyed() {
    this.DoReSetAISuggestionTransaction();
  }
}
